import promobit from './promobit';

const themes = {
  promobit,
};

export default themes;
